import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { Button, Modal, Popover, message } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { deleteCycle } from '../../utils/apiBucherVaslin';

const { confirm } = Modal;

const showDeleteConfirm = (intl, id, refresh, serial) => {
    confirm({
        title: intl.formatMessage(
            {
                id: 'table.cycles.modal.title',
            },
            { id },
        ),
        okText: intl.formatMessage({
            id: 'common.yes',
        }),
        cancelText: intl.formatMessage({
            id: 'common.no',
        }),
        okType: 'danger',
        async onOk() {
            const { isSuccess, isUnauthorized, errorMessage, errorDetail } = await deleteCycle(id, serial);

            if (isSuccess) {
                message.success(
                    intl.formatMessage(
                        {
                            id: 'table.cycles.success',
                        },
                        { id },
                    ),
                    5,
                );

                refresh();

                return;
            }
            Modal.error({
                title: isUnauthorized
                ? intl.formatMessage({ id: 'error.unauthorized.title' })
                : intl.formatMessage({
                    id: 'table.cycles.fail',
                }),
                content: isUnauthorized
                ? intl.formatMessage({ id: 'error.unauthorized.message' })
                : errorDetail
            });
        },
    });
};

const DeleteCycle = ({ disabled, intl, id, refresh, serial }) => (
    <Popover content={<FormattedMessage id="table.cycles.delete" />}>
        <Button htmlType="button" type="danger" onClick={() => showDeleteConfirm(intl, id, refresh, serial)} disabled={disabled}>
            <FontAwesomeIcon icon="trash-alt" />
        </Button>
    </Popover>
);

DeleteCycle.propTypes = {
    intl: intlShape.isRequired,
    disabled: PropTypes.bool,
    id: PropTypes.string.isRequired,
    refresh: PropTypes.func.isRequired,
    serial: PropTypes.string.isRequired,
};

export default injectIntl(DeleteCycle);
